"use client"

import NumberFlowBase from "@number-flow/react"
import { useEffect, useState } from "react"

type Props = {
    value: number
    className?: string
    delay?: number
    format?: any
    prefix?: string
    suffix?: string
}

export function NumberFlow({ value, className, delay = 0, format, prefix, suffix }: Props) {
    const [displayValue, setDisplayValue] = useState(0)
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    useEffect(() => {
        if (!mounted) return

        const timeout = setTimeout(() => {
            setDisplayValue(value)
        }, delay)
        return () => clearTimeout(timeout)
    }, [value, delay, mounted])

    const baseClass = "font-mono tabular-nums [-webkit-font-smoothing:antialiased] [font-feature-settings:'tnum']"

    return (
        <NumberFlowBase
            value={displayValue}
            className={className ? `${baseClass} ${className}` : baseClass}
            format={format}
            prefix={prefix}
            suffix={suffix}
        />
    )
}

export default NumberFlow
